// @flow
import dispatchAsync from 'utils/dispatchAsync';

import type { ZuzuThunk } from 'types';

type LoginLog = {
  type: 'login',
  createdAt: number,
};
type ContentLog = {
  type: 'like' | 'report' | 'comment',
  title: string,
  reportId: string,
  createdAt: number,
};
export type Log = LoginLog | ContentLog;
export type LoadLogsAction = {
  type: 'LOAD_LOGS',
  payload?: Array<Log>,
  meta: {
    done: boolean,
    error?: boolean,
  },
};
export const LOAD_LOGS = 'LOAD_LOGS';
export const loadLogs = (): ZuzuThunk => async dispatch => {
  return dispatchAsync({
    type: LOAD_LOGS,
    url: '/api/management/session/log',
    method: 'get',
    dispatch,
    transform: payload =>
      [
        ...payload.events,
        { type: 'login', createdAt: payload.lastLoginTime },
      ].sort((a, b) => b.createdAt - a.createdAt),
  });
};



// WEBPACK FOOTER //
// ./src/redux/actions/logs.js